import { useTranslation } from 'react-i18next'

import { Flex, IllustratedMessage, Typography } from '@percent/lemonade'
import { Layout } from '@percent/domain/verifications'
import styles from './InvalidLink.module.scss'

export function InvalidLink() {
  const { t } = useTranslation()

  return (
    <Layout
      termsLabel={t('hostedValidation.footer.terms')}
      privacyLabel={t('hostedValidation.footer.privacy')}
    >
      <Flex direction="column" align="center" gap={8} m="auto">
        <IllustratedMessage illustration="invalid-link" />
        <Typography variant="h2" className={styles.textStyles}>
          {t('hostedValidation.errorMessage.invalidLink')}
        </Typography>
        <Typography className={styles.textStyles}>
          {t('hostedValidation.errorMessage.linkDoesntExist')}
        </Typography>
      </Flex>
    </Layout>
  )
}
